import { ActionType } from 'typesafe-actions'

const actions = {
}

export type EnvironmentAction = ActionType<typeof actions>

export default actions
